import { AnimatedNumber } from './AnimatedNumber'

interface Props {
  value: number | null
  format?: (n: number) => string
  duration?: number
  className?: string
}

export function MetricValue({ value, format, duration, className }: Props) {
  if (value == null) {
    return <span className={className}>—</span>
  }
  return <AnimatedNumber value={value} format={format} duration={duration} className={className} />
}
